var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhysicalItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 15.1875V9.47913L2.16667 6.58329V12.2916L7.16667 15.1875ZM8.83333 15.1875L13.8333 12.2916V6.58329L8.83333 9.47913V15.1875ZM7.16667 17.1041L1.33333 13.75C1.06944 13.5972 0.864583 13.3958 0.71875 13.1458C0.572917 12.8958 0.5 12.618 0.5 12.3125V5.68746C0.5 5.3819 0.572917 5.10413 0.71875 4.85413C0.864583 4.60413 1.06944 4.40274 1.33333 4.24996L7.16667 0.895793C7.43056 0.743015 7.70833 0.666626 8 0.666626C8.29167 0.666626 8.56944 0.743015 8.83333 0.895793L14.6667 4.24996C14.9306 4.40274 15.1354 4.60413 15.2813 4.85413C15.4271 5.10413 15.5 5.3819 15.5 5.68746V12.3125C15.5 12.618 15.4271 12.8958 15.2813 13.1458C15.1354 13.3958 14.9306 13.5972 14.6667 13.75L8.83333 17.1041C8.56944 17.2569 8.29167 17.3333 8 17.3333C7.70833 17.3333 7.43056 17.2569 7.16667 17.1041ZM11.3333 6.10413L12.9375 5.18746L8 2.33329L6.375 3.27079L11.3333 6.10413ZM8 8.04163L9.625 7.10413L4.6875 4.24996L3.0625 5.18746L8 8.04163Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhysicalItem);
export default __webpack_public_path__ + "static/media/icon-physical-item.f0db73b8d38aadb9738491fa9434eef8.svg";
export { ForwardRef as ReactComponent };